import { CurrentUser } from '@uplift/api';
import { useEffect, useState } from 'react';
import { useAlert } from '@uplift/ui-v2';
import { useL10n } from '@uplift/hooks';
import { useVideoContext } from './use-video-context';


export const useParticipantNetworkIssueAlert = (me: CurrentUser) => {
  const alert = useAlert();

  const { room } = useVideoContext();
  const localParticipant = room?.localParticipant;

  const [ networkQualityLevel, setNetworkQualityLevel ] = useState(localParticipant?.networkQualityLevel ?? 0);
  const [ displayAlert, setDisplayAlert ] = useState<number | null>(null);
  const [ countSinceEventSeconds, setCountSinceEventSeconds ] = useState(0);

  const l10n = useL10n();
  // Cleanup of all alerts when this unmounts, given that the only dep is Me, this should only happen when the page unloads

  useEffect(() => {
    return () => {
      alert?.removeAll();
    };
  }, []);

  // The main hook for handling network connection issues
  useEffect(() => {
    const handleNewtorkQualityLevelChange = (newNetworkQualityLevel: number) => {
      setNetworkQualityLevel(newNetworkQualityLevel);
    };

    const handleEventCountInterval = () => {
      if (networkQualityLevel <= 1 && !displayAlert) {
        setCountSinceEventSeconds(countSinceEventSeconds + 1);
        if (countSinceEventSeconds === 7) {
          const a = alert.info(l10n.sessions.networkConnectivityAlert(me.role), {
            persist: true
          });

          setDisplayAlert(a);
        }
      } else if (displayAlert) {
        if (networkQualityLevel >= 2) {
          setCountSinceEventSeconds(countSinceEventSeconds + 1);
          if (countSinceEventSeconds >= 5) {
            if (displayAlert) alert.remove(displayAlert);
            setCountSinceEventSeconds(0);
            setDisplayAlert(null);
          }
        } else {
          setCountSinceEventSeconds(0);
        }
      }
    };

    localParticipant?.on('networkQualityLevelChanged', handleNewtorkQualityLevelChange);
    const i = setInterval(handleEventCountInterval, 1000);

    return () => {
      // Important to cleanup listeners and intervals.
      localParticipant?.off('networkQualityLevelChanged', handleNewtorkQualityLevelChange);
      clearInterval(i);
    };
  });
};
